var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5375 0.292486L6.4175 4.17249L10.2975 0.292486C10.4843 0.105233 10.738 0 11.0025 0C11.267 0 11.5207 0.105233 11.7075 0.292486C12.0975 0.682486 12.0975 1.31249 11.7075 1.70249L7.1175 6.29249C6.7275 6.68249 6.0975 6.68249 5.7075 6.29249L1.1175 1.70249C0.7275 1.31249 0.7275 0.682486 1.1175 0.292486C1.5075 -0.0875144 2.1475 -0.0975144 2.5375 0.292486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.6af00961ffd594b9b42262d68bd17aab.svg";
export { ForwardRef as ReactComponent };